import React, { useEffect, useState, Fragment,useContext } from "react";
import Layout from "components/sales/layoutChange/layout";
import TableSection from "components/sales/tableSection/tableSection";
import { ArrowRight, Filter, tick } from "assets/images/imageData";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import AddPaymentPopup from "components/sales/paymentPortal/addPayment/addPaymentPopup";
import 'components/sales/layoutChange/layout.css';
import './vendorstyle.css';
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from "components/sales/modal/modal";
import Images from "assets/images/imageData";


const VendorRequest = ({
  getVendorRequestSubmit,
  getDepartment,
  vendorDepartment,
  history,
}) => {
  const [teamId, setTeamId] = useState();
  const [isdisable, setIsdisable] = useState(false);
  const [departmentId, setDepartmentId] = useState();
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const [isModal, setIsModal] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [inputList, setInputList] = useState([{firm_name:'',vendor_name:'',department:'',mail_id:'',send_to:''}]);

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(localStorage.getItem("roles"));
      roles && setIsRoleId(roles[0].pivot.role_id);
    })();
  }, []);


  

    useEffect(() => {
        (async () => {
          setIsLoading(true);
          await getDepartment();
          setIsLoading(false);
        })();
    }, [getDepartment]);

  const handleInputValue = (val, key) => {
    // console.log(val);
    const list = [...inputList];
    list[0][key] = val;
    setInputList([...list]);
  };

  const submitVendorReq = async () => {
    const formData = inputList[0];
    if (
      !formData.firm_name ||
      !formData.vendor_name ||
      !formData.mail_id ||
      !formData.send_to ||
      !formData.group
    ) {
      return;
    }

    setIsdisable(true);
    setIsLoading(true);

    try {
      const data = {
        name_of_firm: formData.firm_name,
        vendor_group: formData.group,
        vendor_name: formData.vendor_name,
        email: formData.mail_id,
        send_to: formData.send_to,
      };
      const res = await getVendorRequestSubmit(data);
      if (res) {
        setIsModal(true);
      }
    } finally {
      setIsLoading(false);
      setIsdisable(false);
    }
  };

  const handleModalHide = () => {
    history.push(`${baseUrl}/vendorRequestList`);
    setIsModal(false);
  };
 

  return (
    <Layout
      title={localization.vendorReq}
      isLoading={isLoading}
      searchOption={false}
    >
      <Fragment>
       
        <div className="card">
          <div className="card-header">
          {localization.vendorReq}
            </div>
            <div className="card-body">
              <div className="row">

              <div className="col-md-4">
                <DropDownInput
                    label="Select Vendor Group"
                    data={[
                      {id: "VEND_ CAPITAL",name: "VEND_ CAPITAL"},
                      {id: "VEND_ CLEANER",name: "VEND_ CLEANER"},
                      {id: "VEND_ CONTOPERATION",name: "VEND_ CONTOPERATION"},
                      {id: "VEND_ DEMANDPARK",name: "VEND_ DEMANDPARK"},
                      {id: "VEND_PROC",name: "VEND_PROC"},
                      {id: "VEND_ EV",name: "VEND_ EV"},
                      {id: "VEND_ FACT",name: "VEND_ FACT"},
                      {id: "VEND_ GOVT",name: "VEND_ GOVT"},
                      {id: "VEND_ HUMAN",name: "VEND_ HUMAN"},
                      {id: "VEND_ MALL",name: "VEND_ MALL"},
                      {id: "VEND_ MARKET",name: "VEND_ MARKET"},
                      {id: "VEND_ OS THIRDPARTY",name: "VEND_ OS THIRDPARTY"},
                      {id: "VEND_ POS CON",name: "VEND_ POS CON"},
                      {id: "VEND_ RENT",name: "VEND_ RENT"},
                      {id: "VEND_ TECH",name: "VEND_ VALET"},
                      {id: "VEND_FIN",name: "VEND_FIN"},
                    ]}
                    required
                    // value={isEdit || isView ? rowData?.bank : ''}
                    errorMsg={localization.paymentMode}
                    getIdValue={(val) => {
                      handleInputValue(val.value, 'group', 0);
                    }}
                    // onChange={e => handleInputChange(e, i)}
                    isStarRequired={true}
                  />
                </div>
                {/* <div className="col-md-4">
                  <DropDownInput
                      label={`Department`}
                      data={vendorDepartment?.department}
                      getIdValue={(val) => {
                        handleInputValue(val.value, 'department', 0);
                      }}
                      errorMsg={localization.isRequired}
                      // value={typeVal}
                      required
                      isStarRequired={true}
                    />
                </div>
                 */}
                <div className="col-md-4">
                  <ConstantInput
                      label={localization.firmName}
                      type="text"
                      value={inputList.firm_name}
                      handleChange={(val) => {
                        handleInputValue(val, 'firm_name', 0);
                      }}
                      required
                      isStarRequired={true}
                    
                    />
                </div>
                <div className="col-md-4">
                  <ConstantInput
                      label={localization.contactPersonName}
                      type="text"
                      value={inputList.vendor_name}
                      handleChange={(val) => {
                        handleInputValue(val, 'vendor_name', 0);
                      }}
                      required
                      isStarRequired={true}
                  
                />
                </div>
                <div className="col-md-4">
                  <ConstantInput
                    label={localization.emailIdNo}
                    type="text"
                    value={inputList.mail_id}
                    handleChange={(val) => {
                      handleInputValue(val, 'mail_id', 0);
                    }}
                    required
                    isStarRequired={true}
                  
                />
                </div>
                <div className="col-md-4">
                  <DropDownInput
                    label="Send For Next Step"
                    data={[
                      {
                        id: "Vendor",
                        name: "Send to Vendor ",
                      },
                      {
                        id: "Self",
                        name: "Send to You",
                      },
                    ]}
                    required
                    errorMsg={localization.paymentMode}
                    getIdValue={(val) => {
                      handleInputValue(val.id, "send_to",'0');
                    }}
                    // onChange={e => handleInputChange(e, i)}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-md-12">
                <Button onClick={submitVendorReq} disabled={isdisable || isLoading}>
                    {localization.submitDtl} 
                  </Button>
                </div>
              </div>
            </div>
            
              
        </div>
        <ModalPop
            title='Successfully Sent'
            show={isModal}
            handleModalHide={handleModalHide}
            keyboard
          >
            <div className="text-center">
              
              <div className="success">
                <img src={Images?.tick} alt="" />
              </div>
             
              <h5>Create Vendor Request Sent!</h5>
             
            
            </div>
          </ModalPop>
      </Fragment>

   </Layout>
  );
};

export default VendorRequest;
